module.exports = __webpack_public_path__ + "img/email_templates.cb91f4ac.png";